const zh = {
  meta: {
    title: 'Agathit Domrongwatanagoon，首席技术官与全栈开发工程师',
    description:
      'Agathit Domrongwatanagoon，常驻曼谷的首席技术官与全栈开发工程师。FindBack 创始人，Somchai Aluminium 与 SAG All Color 数字化转型团队负责人。',
  },
  ui: {
    nav: { work: '作品', career: '经历', skills: '技能', about: '关于' },
    mainNav: '主导航',
    language: '语言',
    openMenu: '打开菜单',
    closeMenu: '关闭菜单',
    emailMe: '发邮件给我',
    seeWork: '查看作品',
    copyEmail: '复制邮箱地址',
    emailCopied: '邮箱地址已复制',
    highlights: '亮点',
    filterLabel: '按类型筛选作品',
    techUsed: '使用的技术',
    visit: '访问',
    showDetails: '查看详情',
    hideDetails: '收起详情',
    showAllProjects: (count) => `查看全部 ${count} 个作品`,
    showFewerProjects: '收起',
    headings: {
      work: '精选作品',
      career: '职业经历',
      skills: '技术栈',
      about: '工作之外',
      contact: '正在招人，或有项目想合作？给我发邮件。',
    },
    education: '教育背景',
    activities: '活动',
    interests: '兴趣',
    signal: {
      aria: '一条从平滑的模拟波形变为数字采样的信号',
      analog: '模拟信号',
      sampled: (bits, levels) => `${bits} 位采样，${levels} 个量化级`,
      hint: '在信号上左右移动可改变采样点，向上移动可增加位数。',
    },
  },
  person: {
    location: '泰国曼谷',
    intro:
      '我把依赖人工的业务流程做成员工每天都在用的软件，并保障它在生产环境中稳定运行。现任 Software Marketplace 首席技术官、FindBack 创始人，以及 Somchai Aluminium 和 SAG All Color 的数字化转型团队负责人。',
  },
  proof: {
    lead: 'Western Digital 采用了我开发的污染物检测软件，并为其申请了专利。',
    supporting: [
      '早期创业公司 Software Marketplace 的首席技术官兼唯一工程师，FindBack 创始人。FindBack 是面向全泰国的免费失物招领平台。',
      'Somchai Aluminium 与 SAG All Color 数字化转型团队负责人，负责内部系统的设计、部署与运维。',
      '此前为 Pizza Hut Thailand 和 NXP Semiconductors 开发软件。',
    ],
  },
  filters: { all: '全部', web: 'Web 平台', ai: 'AI 与机器视觉' },
  projects: {
    mesa: {
      title: 'MESA Density 颗粒检测',
      place: 'Western Digital',
      summary: '用于检测硬盘盘片上微小污染物的图像处理软件。Western Digital 已采用并申请专利。',
      details:
        '运用图像处理技术改进了硬盘污染物检测算法，并开发了便于技术员操作的桌面应用程序。该方案已被 Western Digital 采用并申请专利。',
    },
    'project-quotation': {
      title: '项目与报价管理系统',
      place: 'Somchai Aluminium',
      summary: '管理铝材与玻璃业务的销售单据，从报价单到送货单。员工每天都在使用。',
      details:
        '涵盖客户资料、多版本报价单、加价、佣金与折扣、审批、项目、发票、收款记录和送货单。文档在服务器端生成 A4 PDF，报价单支持泰语、中文和英语三种语言。系统按角色控制权限，并保留审计日志。我负责系统的设计、部署以及生产环境的运维。',
    },
    findback: {
      title: 'FindBack',
      place: '创始人',
      summary: '面向全泰国的免费失物招领平台，可发布和查找信息，并在地图上显示。',
      details:
        '用户可以按类别发布丢失或拾到的物品，例如钱包、手机、钥匙、证件、宠物和车辆，并在地图上浏览信息。平台免费使用。我是该服务的所有者和运营者。',
    },
    'self-hosted-platform': {
      title: '承载六个 Web 应用的自托管平台',
      place: 'Somchai Aluminium 与 SAG All Color',
      summary: '一台 Ubuntu 服务器，通过 Docker 运行六个 Web 应用，前端由 Nginx 和 Cloudflare 接入，数据库每晚备份。',
      details:
        '生产环境、演示环境、数据库和反向代理各自运行在独立的 Docker 网络中。每次部署都遵循书面的、可重复的流程：备份数据库和镜像，执行迁移，检查结果，并保留回滚方案。Web 流量只能经由 Cloudflare 到达服务器，数据库不对互联网开放，办公室通过 WireGuard VPN 访问。',
    },
    central: {
      title: 'Pizza Hut Central Web 平台',
      place: 'PH Capital (Pizza Hut)',
      summary: '用于优惠券、门店管理、员工档案和客户数据的内部运营平台。',
      details:
        '开发并维护用于优惠券、门店管理、员工档案和客户数据的内部运营平台。前端使用 React，后端使用 Express.js 搭配 MSSQL 数据库提供 API，并将后端划分为 Controller / Router / Service 三层。',
    },
    'lot-status': {
      title: '批次状态追踪系统',
      place: 'NXP Semiconductors',
      summary: '追踪半导体批次在生产过程中的状态，并提供实时生产数据看板。',
      details:
        '在 NXP 使用 Angular（前端）、C#/.NET（后端）和 MSSQL 开发了半导体生产追踪系统，并使用 Kibana、Elasticsearch（ELK Stack）和 Grafana 搭建实时看板，用于生产数据可视化。',
    },
    'predictive-maintenance': {
      title: '基于机器学习的预测性维护',
      place: 'NXP Semiconductors',
      summary: '预测半导体设备何时需要维护的机器学习模型。',
      details:
        '在 NXP 使用 Python 主导 FabKey 预测性维护项目，实现了 Logistic Regression、KNN、Decision Tree、SVM 和 Ensemble 等模型，用于预测半导体设备的维护需求。',
    },
    'glass-production-tracking': {
      title: '玻璃生产追踪系统',
      place: 'Somchai Aluminium',
      summary: '通过手机摄像头扫描条码，追踪每片玻璃经过的生产工位。目前处于员工测试阶段。',
      details:
        '操作员在每个工位用手机摄像头扫描条码，所有屏幕通过 WebSocket 实时更新。设备与工位配对，操作员使用 PIN 登录。系统已部署，正在由员工测试，尚未正式投入生产使用。',
    },
    'pricing-calculator': {
      title: '铝材与玻璃工程报价计算器',
      place: 'Somchai Aluminium',
      summary: '根据模板、型材截面和物料清单计算工程价格。目前处于员工测试阶段。',
      details:
        '根据产品模板、型材截面和物料清单计算铝材与玻璃工程的价格。系统已部署，正在由员工测试，尚未正式投入生产使用。',
    },
    'line-ordering': {
      title: 'LINE 订餐集成',
      place: 'PH Capital (Pizza Hut)',
      summary: '通过 LINE 官方账号实现订餐和客服自动化。',
      details:
        '通过 LINE Messaging API 与 LINE 官方账号集成，实现订餐和客服自动化。还开发了用于问卷收集、联系记录报告和 WordPress 自动部署的 Web 工具。',
    },
    'fpga-rl': {
      title: '强化学习的 FPGA 实现',
      place: null,
      summary: '使用 VHDL 在 FPGA 上以数字电路实现 Q-learning。',
      details:
        '使用 VHDL 在 FPGA 上设计实现 Q-learning 算法的数字电路，并针对硬件性能进行优化。使用 OpenAI Gym 搭建测试环境以验证决策问题，将强化学习的思路应用于硬件加速。',
    },
  },
  experiences: [
    {
      id: 'software-marketplace',
      company: 'Software Marketplace',
      role: '首席技术官',
      period: '至今',
      description: '一家早期软件交易平台创业公司的唯一工程师，负责整个产品：架构、开发、部署和运维。',
      achievements: [],
    },
    {
      id: 'findback',
      company: 'FindBack (findbacktech.com)',
      role: '创始人',
      period: '至今',
      description: '拥有并运营 FindBack，一个面向全泰国的免费失物招领平台。',
      achievements: [],
    },
    {
      id: 'somchai-sag',
      company: 'Somchai Aluminium Co., Ltd. 与 SAG All Color Co., Ltd.',
      role: '数字化转型团队负责人',
      period: '至今',
      description:
        '为一家铝材与玻璃制造商及其粉末喷涂关联公司主导数字化转型：设计内部系统，完成部署，并保障系统持续运行。',
      achievements: [
        '将项目与报价管理系统投入日常使用，涵盖报价、审批、发票、收款和送货单，支持泰语、中文和英语',
        '搭建一台自托管服务器，通过 Docker 运行六个 Web 应用，由 Nginx 和 Cloudflare 接入，每晚备份，并建立可重复的部署流程',
        '部署了玻璃生产追踪系统和报价计算器，目前均处于员工测试阶段',
        '正在将库存和采购工作从 AppSheet 与 Google Sheets 迁移到自研系统',
      ],
    },
    {
      id: 'ph-capital',
      company: 'PH Capital (Pizza Hut)',
      role: '高级软件开发工程师',
      period: '2024年2月 至 2025年7月',
      description: '主导 Pizza Hut Thailand 运营所需的 Web 应用和内部工具的开发，并指导初级开发人员。',
      achievements: [
        "开发并维护内部运营使用的 'Central' Web 平台：优惠券、门店管理、员工档案和客户数据",
        '使用 React 开发前端，使用 Express.js 搭配 MSSQL 数据库开发后端 API',
        '将后端逻辑清晰地划分为 Controller / Router / Service 三层',
        '通过 LINE Messaging API 与 LINE 官方账号集成，实现订餐和客服自动化',
        '开发了用于问卷收集、联系记录报告和 WordPress 自动部署的 Web 工具',
      ],
    },
    {
      id: 'nxp',
      company: 'NXP Semiconductors',
      role: '软件工程师',
      period: '2023年1月 至 2024年1月',
      description: '为半导体制造与测试开发企业级软件，与跨职能团队合作实施质量保证和生产监控系统。',
      achievements: [
        '使用 Angular（前端）、C#/.NET（后端）和 MSSQL 开发批次状态追踪系统',
        '使用 Kibana、Elasticsearch（ELK Stack）和 Grafana 搭建实时看板，用于生产数据可视化',
        '使用 Docker 对应用和服务进行容器化',
        '使用 Python 主导基于机器学习的 FabKey 预测性维护项目：实现了 Logistic Regression、KNN、Decision Tree、SVM 和 Ensemble 等模型',
      ],
    },
    {
      id: 'western-digital',
      company: 'Western Digital Storage',
      role: '软件工程实习生',
      period: '2022年5月 至 2023年1月',
      description: '参与改进硬盘污染物检测的图像处理算法，并为工程师和技术员开发桌面应用程序。',
      achievements: [
        '使用 Python 和 OpenCV 开发了检测硬盘盘片上微小污染物的桌面软件',
        '通过图像滤波技术和更好的信号分离减少了误报',
        '集成了 C# 前端，供用户操作检测系统',
        '该方案已被公司采用并申请专利',
      ],
    },
  ],
  skillGroups: {
    frontend: '前端',
    backend: '后端',
    data: '数据',
    infrastructure: '基础设施',
    ai: 'AI 与机器视觉',
    hardware: '硬件',
    markets: '交易工具',
  },
  markets: {
    title: '交易与市场',
    lead: '我交易差价合约（CFD）和股票，并自己编写交易工具。',
    points: [
      { term: '价格行为', text: '直接从图表解读价格走势，以 pin bar 作为主要信号。' },
      { term: '市场微观结构', text: '理解流动性和订单流如何推动价格，包括止损猎杀和流动性扫荡。' },
      { term: '宏观背景', text: '关注经济与政治，以及它们如何决定市场方向。' },
      { term: '自动化', text: '使用 MQL5 为 MetaTrader 5 编写交易脚本和指标。' },
    ],
  },
  education: [
    {
      school: "King Mongkut's Institute of Technology Ladkrabang",
      detail: '电信工程学士',
      period: '2019 至 2023',
    },
    {
      school: "King Mongkut's Institute of Technology Ladkrabang",
      detail: '辅修：AI 与深度学习',
      period: '2019 至 2023',
    },
    {
      school: 'Benchamaracharungsarit School',
      detail: '数学与科学课程',
      period: '2016 至 2019',
    },
  ],
  activities: [
    'KMITL 电信工程系学生会副主席，2019 至 2023',
    'KMITL Physics and Mathematical Academy 辅导教师，2019 至 2021',
    '在 Huawei ICT Academy 学习 ICT',
    '现场参加 DDCamp 5',
  ],
  interests: [
    'AIAT MOOC 与 Super AI Engineering 第二季',
    'KMITL Football Club Academy',
    '游泳、足球、篮球和泰拳',
  ],
};

export default zh;
